
import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";   
import usePriceEdgeSchedule from "./hooks/usePriceEdgeSchedule";  

const PriceEdgeSchedule = () => {  
const PriceEdgeScheduleData = usePriceEdgeSchedule();  
return (  
<div class="container container-fluid">  
    {PriceEdgeScheduleData.leftButtons.length > 0 && <ButtonsSection
            ctaButtons={PriceEdgeScheduleData.leftButtons}
            align="left"
      />}
    <div className="header-section">  
    <h1>  
        {PriceEdgeScheduleData.screen_title} -{" "}  
        <span className="heading-cod">{PriceEdgeScheduleData.screenNumber}</span>  
    </h1>  
    </div>  
    <SearchBox  
    formFields={PriceEdgeScheduleData.formFields}  
    dropdownValues={PriceEdgeScheduleData.dropdownValues}  
    paramsData={PriceEdgeScheduleData.paramsData}  
    updataParamData={PriceEdgeScheduleData.updateParamData}  
    />  
    <ButtonsSection ctaButtons={PriceEdgeScheduleData.ctaButtons} />  
    <DisplayTable  
    data={PriceEdgeScheduleData.data}  
    parmKey={PriceEdgeScheduleData.parmKey}  
    menuOptions={PriceEdgeScheduleData.menuOptions}  
    tableHeaders={PriceEdgeScheduleData.columnDef}  
    setRowData={PriceEdgeScheduleData.setRowData}  
    selectedPriceSchedules={PriceEdgeScheduleData.selectedRows}  
    setSelectedPriceSchedules={PriceEdgeScheduleData.setSelectedRows} 
    selectMode={PriceEdgeScheduleData.selectMode} 
    />  
    <div className="paginator-container">  
    <NextGenPaginator  
        first={PriceEdgeScheduleData.first}  
        rows={PriceEdgeScheduleData.rows}  
        totalRecords={PriceEdgeScheduleData.totalRecords}  
        currentPage={PriceEdgeScheduleData.currentPage}  
        rowsPerPageOptions={[10, 25, 50]}  
        onPageChange={PriceEdgeScheduleData.onPageChange}  
    />  
    </div>  
    {PriceEdgeScheduleData.isConfirmationModalOpen && (  
    <ConfirmationModal  
        isOpen={PriceEdgeScheduleData.isConfirmationModalOpen}  
        onRequestClose={PriceEdgeScheduleData.closeConfirmationModal}  
        onBack={PriceEdgeScheduleData.closeConfirmationModal}  
        onSave={PriceEdgeScheduleData.deletePriceEdgeSchedule}  
        confirmLabel="Confirm(Y/N)"  
        options={[  
        { label: "N-No", value: "no" },  
        { label: "Y-Yes", value: "yes" },  
        ]}  
        setSelectedOption={PriceEdgeScheduleData.setSelectedOption}  
    />  
    )}  
</div>  
);  
};  

export default PriceEdgeSchedule;  